import $ from 'jquery';

// import CCAShareCheckbox from '@/components/form/CCAShareCheckbox.vue';

export default {
    name: 'manage-constante',
    // components: { CCAShareCheckbox },
    props: {
        consultation: Object,
        evolution_id: Number,
        user_id: Number,
        modal_toggler: Number,
        selected_constant: Object,
        data_to_be_deleted: Object,
        is_from_salle: Number
    },
    data() {
        return {
            constantes: {
                temperature: "",
                tension_arterielle: "",
                poids: "",
                poids_unit: "Kg",
                taille: "",
                taille_unit: "cm",
                pouls: "",
                bras_gauche_ta: "",
                bras_gauche_unit: "cmHg",
                bras_droit_ta: "",
                bras_droit_unit: "cmHg",
                unite_ta: "mmHg",
                v_model_o: [],
            },
            imc: "",

            save_loading: false,
            is_loading: true,

            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,

            additional_loading: true,
            additional_empty: false,
            selected_champ: [],
            o_occurence: [],
            filtered_occurence: []
        }
    },

    watch: {
        modal_toggler() {
            this.fillConstant()
            this.refreshChampExamenClinique()
            this.is_error = false
            this.permission_is_denied = false
        }
    },

    computed: {
        hasConstantes() {
            return Object.values(this.constantes).some(value => value !== "" && value !== "Kg" && value !== "cm" && value !== "cmHg" && value !== "mmHg" && !Array.isArray(value));
        },
        champ() {
            return this.DataFormat()
        },

        consultation_constante_complementaires() {
            return this.$store.getters["consultation_constante_complementaires"];
        },

        liste_occurences() {
            return this.$store.getters["liste_occurences"];
        },
    },

    mounted() {
        // Liste occurences
        this.$store.dispatch("getListeOccurences")
    },

    methods: {
        fillConstant() {
            if (this.selected_constant.constante_group_id > 0) {
                this.constantes.temperature = this.selected_constant.constante.temperature
                this.constantes.poids = this.selected_constant.constante.poids
                this.constantes.poids_unit = (this.selected_constant.constante.unite_poids != null)?this.selected_constant.constante.unite_poids:"g"
                this.constantes.taille = this.selected_constant.constante.taille
                this.constantes.taille_unit = (this.selected_constant.constante.unite_taille != null)?this.selected_constant.constante.unite_taille:"m"
                this.constantes.pouls = this.selected_constant.constante.pouls
                this.constantes.bras_gauche_ta = this.selected_constant.constante.ta_gauche
                this.constantes.bras_gauche_unit = "cmHg"
                this.constantes.bras_droit_ta = this.selected_constant.constante.ta_droit
                this.constantes.bras_droit_unit = "cmHg"
                this.constantes.unite_ta = (this.selected_constant.constante.ta_droit == null || this.selected_constant.constante.ta_gauche == null)?"mmHg":this.selected_constant.constante.ta_droit_unit

                this.computeIMC()
            } else {
                this.constantes = {
                    temperature: "",
                    tension_arterielle: "",
                    poids: "",
                    poids_unit: "Kg",
                    taille: "",
                    taille_unit: "cm",
                    pouls: "",
                    bras_gauche_ta: "",
                    bras_gauche_unit: "cmHg",
                    bras_droit_ta: "",
                    bras_droit_unit: "cmHg",
                    unite_ta: "mmHg",
                    v_model_o: [],
                }
                this.selected_champ = []
            }

            
        },

        refreshChampExamenClinique() {
            this.constantes.v_model_o = []
            this.selected_champ = []
            let type_consultation_id = this.consultation.tarif_consultation.type_consultation_id

            let data_param = {
                data_type: 'examen_clinique',
                consultation_id: this.consultation.id,
                constante_group_id: this.selected_constant.constante_group_id,
                en_cours: true,
                type_consultation_id: type_consultation_id
            } 
            
            this.$store.dispatch("getConsultationConstanteComplementaire", data_param).then(() => {
                if (this.consultation_constante_complementaires.length > 0) {
                    this.additional_empty = false
                } else {
                    this.additional_empty = true
                    this.additional_loading = false
                }

                this.consultation_constante_complementaires.forEach((el, ind) => {
                    let contenu = ''
                    let contents = []

                    if (el.contenu.length > 0) {
                        if (el.type_champ != 'Choix multiple') {
                            contenu = el.contenu[0].occurence
                            this.has_content = true
                        } else {
                            contenu = el.contenu
                            contents = contenu
                        }
                    } else {
                        contenu = []
                        contents = []
                    }

                    this.constantes.v_model_o.push({ valeur: contenu, attribut: el.champ_id })
                    this.selected_champ.push({ selected_champ_occurences: contents })
                    this.o_occurence.push('')

                    if (this.consultation_constante_complementaires.length-1 == ind ) {
                        this.additional_loading = false
                    }
                    
                })
                
                
            })
        },

        clearAll(index, selector) {

            $('#' + selector).val('')
            if (index == '1') {
                this.constantes.taille = ''
            } else if (index == '2') {
                this.constantes.temperature = ''
            } else if (index == '3') {
                this.constantes.tension_arterielle = ''
            }
        },

        async computeIMC() {
            var taille = this.constantes.taille
            var poids = this.constantes.poids

            if (taille == null || poids == null || poids == '' || taille == '') {
                this.imc = ''
                return
            } 
            
            taille = (taille && taille != '') ? taille.replace(",", ".") : ''
            if (typeof poids == 'string') {
                poids.replace(",", ".")
            }

            if (this.constantes.taille_unit == 'cm') {
                taille = parseFloat(taille / 100)
            }

            if (this.constantes.poids_unit == 'g') {
                poids = parseFloat(poids / 1000)
            }

            poids = parseFloat(poids)

            this.imc = poids / (taille * taille)
            this.imc = this.imc.toFixed(2)
        },

        async saveConstante() {
            const isValid = await this.$refs.exm_form.validate();
            if (!isValid) {
                return;
            }

            // let data = this.consultationLatest

            if (this.constantes.taille && this.constantes.taille != '') {
                this.constantes.taille = this.constantes.taille.replace(",", ".")
            }

            if (this.constantes.poids && this.constantes.poids != '') {
                this.constantes.poids = this.constantes.poids.replace(",", ".")
            }

            this.constantes.user_id = this.user_id
            this.constantes.evolution_id = this.evolution_id
            this.constantes.group_id = this.selected_constant.constante_group_id
            this.constantes.consultation_id = this.consultation.id
            this.constantes.cste_id = (this.selected_constant.constante_group_id > 0)?this.selected_constant.constante.id:0

            this.save_loading = true;
            console.log(this.constantes);
            console.log(this.selected_champ);

            this.$store.dispatch('saveConsultationConstante', this.constantes).then((response) => {
                
                if (response > 0) {
                    this.$refs.exm_form.reset()
                    if (this.is_from_salle == 0) {
                        this.$emit("emitConstante")
                    } else {
                        this.$emit("emitSalleCOnsultation")
                    }
                    

                    this.$refs.cste_mdl.click()
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },
        examCliniqueSucessMessage: function () {
            this.$toasted.show('Les informations ont été enregistrées avec succès', {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        DataFormat: function () {

            Object.defineProperty(this.de, 'property1', {
                value: 42,
                writable: true
            });
            this.de.property1 = 1
            return this.de
        },
        /**
         * Ajoute le caractère slash (/) après n chiffres
         * @param {*} n 
         * @param {} selector (est l'ID du champ input)
         */
        async formatNumberToSlash(n, selector) {
            let nb_car = $('#' + selector).val().length;
            if (n == '1') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9m ]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + 'm ');
                }
            } else if (n == '2') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9^C°]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + '°');
                } else if (nb_car == 4) {
                    $('#' + selector).val($('#' + selector).val() + 'C');
                }
                this.constantes.temperature = $('#' + selector).val()
            } else if (n == '3') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9/]+/g, ''))

                if (nb_car == 2) {
                    $('#' + selector).val($('#' + selector).val() + '/');
                }
            }
        },

        async formatComma(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,.]+/g, ''))
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        async onlyDigitSlash(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,/]+/g, ''))
        },

        addToOccurence_o(value, index) {
            this.o_occurence[index] = this.o_occurence[index].replace('_', '')

            this.filtered_occurence[index] = [];
            if (value.length >= 2) {
                this.liste_occurences.forEach(
                    el => {
                        if (el.occurence.toLowerCase().includes(value.toLowerCase())) {
                            this.filtered_occurence[index].push(el)
                        }
                    }
                )
            }
        },

        /**
         * Ajouter une nouvelle occurence
         */
        async addNewOccurence(index, value) {
            let j = 0
            let len = this.selected_champ[index].selected_champ_occurences.length

            let tmp_occurence = {
                id: 0,
                occurence: value
            }

            // Verifier si occurence déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.selected_champ[index].selected_champ_occurences.length; i++) {
                    if (value == this.selected_champ[index].selected_champ_occurences[i].occurence) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                await this.selected_champ[index].selected_champ_occurences.push(tmp_occurence);
                // if (!this.has_content) {
                    this.constantes.v_model_o[index].valeur.push(tmp_occurence)
                // }

                this.o_occurence[index] = '_'
                
            }
            this.filtered_occurence = []
        },

        addExistingOccurence(data, index) {
            let j = 0
            let len = this.selected_champ[index].selected_champ_occurences.length

            let tmp_occurence = {}
            this.liste_occurences.forEach(function (el) {
                if (data.occurence == el.occurence) {
                    tmp_occurence = {
                        id: el.champ_id,
                        occurence: el.occurence
                    }
                }
            });

            // Verifier si occurence déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.selected_champ[index].selected_champ_occurences.length; i++) {
                    if (data.occurence == this.selected_champ[index].selected_champ_occurences[i].occurence) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.selected_champ[index].selected_champ_occurences.push(tmp_occurence);
                // if (!this.has_content) {
                    this.constantes.v_model_o[index].valeur.push(tmp_occurence)
                // }

                this.o_occurence[index] = '_'

            }
            this.filtered_occurence = []
        },

        removeOccurence(c_index, removal_index) {
            this.selected_champ[c_index].selected_champ_occurences.splice(removal_index, 1)
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerGroupMotif(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('deleteConsultationConstante', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Constante supprimée avec succès')
                    this.$emit("emitConstante")

                    this.$refs.del_cste.click()
                } else {
                    if (response === -2) {
                        this.permission_is_denied = true
                    }
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        }
    }
}


